import { Children, isValidElement, ReactElement, ReactNode } from "react";
import { SteppedModalStep, SteppedModalStepProps } from "./stepped-modal-step";
import { SteppedModalFooter } from "./stepped-modal-footer";

/**
 * Extract the SteppedModal.Step children so the header stepper and body can be derived from them.
 */
export const getSteps = (children: ReactNode): ReactElement<SteppedModalStepProps>[] =>
    Children.toArray(children).filter(
        (child): child is ReactElement<SteppedModalStepProps> =>
            isValidElement(child) && child.type === SteppedModalStep
    );

/**
 * Extract the SteppedModal.Footer child (if any) so it can be rendered beneath the body.
 */
export const getFooter = (children: ReactNode): ReactNode =>
    Children.toArray(children).find((child) => isValidElement(child) && child.type === SteppedModalFooter);

/**
 * Clamp a (possibly out-of-range) active step index to a valid step. Returns 0 when there are no
 * steps, otherwise the nearest valid index in [0, stepsCount - 1]. This guards the body from
 * rendering `undefined` and the Mantine Stepper from receiving an invalid index.
 */
export const clampStepIndex = (active: number, stepsCount: number): number =>
    stepsCount === 0 ? 0 : Math.min(Math.max(active, 0), stepsCount - 1);
